
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eE4tp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jVdlG = parcelRequire("jVdlG");


var $f1UXy = parcelRequire("f1UXy");


var $45O09 = parcelRequire("45O09");


var $6m2p9 = parcelRequire("6m2p9");


var $dVbiN = parcelRequire("dVbiN");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");


var $hMAfQ = parcelRequire("hMAfQ");

/* panel-compiled.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
* Compiled branch of the `platform_editor_static_css` experiment.
* Used via `componentWithCondition` in `panel.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ 
var $hekY6 = parcelRequire("hekY6");








var $7Y8M5 = parcelRequire("7Y8M5");


var $lqPdm = parcelRequire("lqPdm");


var $iDrrr = parcelRequire("iDrrr");




// To fix alignment issues with custom icons, vertical alignment is updated.
const $4d609318393ff70c$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7Y8M5.akEditorCustomIconSize)) / 2;
const $4d609318393ff70c$var$panelEmojiImageVerticalAlignment = $4d609318393ff70c$var$panelEmojiSpriteVerticalAlignment - 1;
const $4d609318393ff70c$var$blockNodesVerticalMargin = '0.75rem';
const $4d609318393ff70c$var$akEditorTableCellMinWidth = 48;
const $4d609318393ff70c$var$panelBaseStyles = null;
const $4d609318393ff70c$var$panelHasNoIconStyles = null;
const $4d609318393ff70c$var$panelInfoIconStyles = null;
const $4d609318393ff70c$var$panelNestedIconStyles = null;
const $4d609318393ff70c$var$nestedPanelStyles = null;
const $4d609318393ff70c$var$panelCustomBackground = null;
const $4d609318393ff70c$export$94e2a9c6f6399451 = ({ backgroundColor: backgroundColor, children: children, className: className, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $lqPdm.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1qha04zXzM _34JGkheUER _2dCaV6dnbC _1ZyHZRdnbC _3Pw1A6dnbC _0kyFW47dHp _2ZkKe8dnbC _46uUjbAEMG _1hgRbCFQfX _38nGYsFQfX _14J9EBdnbC _04gIdHdnbC _10M5brdnbC _2ImbiZ2ADO _3kJdBd5zaO _4uuVdp2ADO _0pjkQE2ADO _3ChsxZpJKa _31lJCMQ4SZ _2XGNQoRAKS _2CevyrzUZr _0rBUdFwPeg _20YGymVva3 _1eI8i4OLYo _3MlmhNdnbC _4qk8MDNHnM _2v4YBTNHnM _3YIzDnPvdi _432vAn2ADO _3ciRU3DIqT _0owctlYbGa _2aXapiYbGa _2mqsnHYbGa _3TSj5JYbGa _4G5wq2OTqR _3ven9A6bAP _32CRbNt2nV _4pE20TccYA _3w76BVpgTj _0u1QYY7vQP _20ks1FvbI6 _1yybm3B8KG _2XWqwITNil _0VW2VRV6wL _14pIdGfyEX _3rvVc156u3 _4nE2ywspgB _2L2l7zsDFP _3ojpvb7j8z _1R6fDRV6wL _16NhUyfyEX",
            (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_nest_table_in_panel_patch_2') && "_30Gy176bAP",
            !hasIcon && "_4wiAFv8HPE _36o8sY8HPE",
            props['data-panel-type'] === (0, $jVdlG.PanelType).CUSTOM && backgroundColor && "_2vNvUo1OkO",
            "_0Cp0lv8HPE _1IjCxx8HPE",
            "_4xRkeHOeNX",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- intentional: custom panel background is dynamic via CSS variable
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        }
    }, children);
};
$4d609318393ff70c$export$94e2a9c6f6399451.displayName = 'PanelStyledCompiled';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
* Emotion branch of the `platform_editor_static_css` experiment.
* Used via `componentWithCondition` in `panel.tsx`.
*
* Cleanup: delete this file once the experiment has shipped.
*/ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");
















function $2d7c1d50ae8acd88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To fix alignment issues with custom icons, vertical alignment is updated.
const $2d7c1d50ae8acd88$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7Y8M5.akEditorCustomIconSize)) / 2;
const $2d7c1d50ae8acd88$var$panelEmojiImageVerticalAlignment = $2d7c1d50ae8acd88$var$panelEmojiSpriteVerticalAlignment - 1;
const $2d7c1d50ae8acd88$var$blockNodesVerticalMargin = '0.75rem';
const $2d7c1d50ae8acd88$var$akEditorTableCellMinWidth = 48;
const $2d7c1d50ae8acd88$var$panelBaseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-panel': {
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${$2d7c1d50ae8acd88$var$blockNodesVerticalMargin} 0 0`,
        paddingTop: "var(--ds-space-100, 8px)",
        paddingRight: "var(--ds-space-200, 16px)",
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-100, 8px)",
        minWidth: `${$2d7c1d50ae8acd88$var$akEditorTableCellMinWidth}px`,
        display: 'flex',
        position: 'relative',
        alignItems: 'normal',
        wordBreak: 'break-word',
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
        color: 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__icon': {
            flexShrink: 0,
            height: "var(--ds-space-300, 24px)",
            width: "var(--ds-space-300, 24px)",
            boxSizing: 'content-box',
            paddingRight: "var(--ds-space-100, 8px)",
            textAlign: 'center',
            userSelect: 'none',
            MozUserSelect: 'none',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '0.1em',
            color: "var(--ds-icon-information, #357DE8)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span': {
                verticalAlign: 'middle',
                display: 'inline-flex'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-sprite': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$2d7c1d50ae8acd88$var$panelEmojiSpriteVerticalAlignment}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.emoji-common-emoji-image': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                verticalAlign: `${$2d7c1d50ae8acd88$var$panelEmojiImageVerticalAlignment}px`,
                // Vertical align only works for inline-block elements in Firefox
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '@-moz-document url-prefix()': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    img: {
                        display: 'inline-block'
                    }
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
            flex: '1 0 0',
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="note"]': {
            backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-discovery, #AF59E1)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        '&[data-panel-type="tip"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #6A9A23)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="warning"]': {
            backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-warning, #E06C00)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="error"]': {
            backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-danger, #C9372C)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-panel-type="success"]': {
            backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                color: "var(--ds-icon-success, #6A9A23)"
            }
        }
    }
});
const $2d7c1d50ae8acd88$var$panelHasNoIconStyles = {
    name: "vaqcwq",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}}"
};
const $2d7c1d50ae8acd88$var$panelInfoIconStyles = {
    name: "dvo37z",
    styles: "&.ak-editor-panel[data-panel-type=\"info\"]{.ak-editor-panel__icon{color:var(--ds-icon-information, #357DE8);}}"
};
const $2d7c1d50ae8acd88$var$panelNestedIconStyles = {
    name: "dsr7j7",
    styles: "&.ak-editor-panel__no-icon{padding-left:var(--ds-space-150, 12px);padding-right:var(--ds-space-150, 12px);}"
};
const $2d7c1d50ae8acd88$var$nestedPanelStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content .ak-editor-panel': {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $2d7c1d50ae8acd88$var$panelCustomBackground = {
    name: "bjtns3",
    styles: "&.ak-editor-panel{&[data-panel-type=\"custom\"]{background-color:var(--ak-renderer-panel-custom-bg-color);}}"
};
const $2d7c1d50ae8acd88$export$368e668f620b51a7 = ({ backgroundColor: backgroundColor, hasIcon: hasIcon, ...props })=>{
    const customBackgroundColor = backgroundColor ? (0, $lqPdm.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : undefined;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        {
            '--ak-renderer-panel-custom-bg-color': customBackgroundColor
        },
        css: [
            $2d7c1d50ae8acd88$var$panelBaseStyles,
            (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_nest_table_in_panel_patch_2') && $2d7c1d50ae8acd88$var$panelInfoIconStyles,
            !hasIcon && $2d7c1d50ae8acd88$var$panelHasNoIconStyles,
            props['data-panel-type'] === (0, $jVdlG.PanelType).CUSTOM && backgroundColor && $2d7c1d50ae8acd88$var$panelCustomBackground,
            $2d7c1d50ae8acd88$var$panelNestedIconStyles,
            $2d7c1d50ae8acd88$var$nestedPanelStyles
        ],
        ...props
    }, props.children);
};
$2d7c1d50ae8acd88$export$368e668f620b51a7.displayName = 'PanelStyledEmotion';


const $74bb1629404fd5f5$var$panelIcons = {
    info: (0, $f1UXy.PanelInfoIcon),
    success: (0, $f1UXy.PanelSuccessIcon),
    note: (0, $f1UXy.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))),
    warning: (0, $f1UXy.PanelWarningIcon),
    error: (0, $f1UXy.PanelErrorIcon),
    custom: (0, (/*@__PURE__*/$parcel$interopDefault($6m2p9)))
};
const $74bb1629404fd5f5$var$PanelStyledMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $4d609318393ff70c$export$94e2a9c6f6399451), (0, $2d7c1d50ae8acd88$export$368e668f620b51a7));
const $74bb1629404fd5f5$var$Panel = (props)=>{
    const { allowCustomPanels: allowCustomPanels, panelType: type, panelColor: panelColor, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText, providers: providers, children: children, localId: localId } = props;
    // only allow custom panel type if flag is set
    // otherwise fall back to info if custom panel is given
    const panelType = allowCustomPanels ? type : type === (0, $jVdlG.PanelType).CUSTOM ? (0, $jVdlG.PanelType).INFO : type;
    const getIcon = ()=>{
        if (panelType === (0, $jVdlG.PanelType).CUSTOM) {
            if (panelIcon && providers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMAfQ.default), {
                id: panelIconId,
                text: panelIconText,
                shortName: panelIcon,
                providers: providers
            });
            return null;
        }
        const Icon = $74bb1629404fd5f5$var$panelIcons[panelType];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: `${panelType} panel`
        });
    };
    const icon = getIcon();
    const renderIcon = ()=>{
        if (icon) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $45O09.PanelSharedCssClassName).icon
        }, icon);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74bb1629404fd5f5$var$PanelStyledMigration, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $45O09.PanelSharedCssClassName).prefix,
        "data-local-id": localId,
        "data-panel-type": panelType,
        "data-panel-color": panelColor,
        "data-panel-icon": panelIcon,
        "data-panel-icon-id": panelIconId,
        "data-panel-icon-text": panelIconText,
        backgroundColor: panelColor,
        hasIcon: Boolean(icon)
    }, renderIcon(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $45O09.PanelSharedCssClassName).content
    }, children));
};
var $74bb1629404fd5f5$export$2e2bcd8739ae039 = $74bb1629404fd5f5$var$Panel;
module.exports["default"] = $74bb1629404fd5f5$export$2e2bcd8739ae039;

});


//# sourceMappingURL=panel.0604452b.js.map
